import { Typography } from "@jti/ui/components/Typography";

import styles from "./ProductHeading.module.scss";

type ProductHeadingProps = {
  description?: string;
  productName: string;
  badgeText?: string;
  hasBadge?: boolean;
};

export const ProductHeading = ({ description, productName, badgeText, hasBadge = false }: ProductHeadingProps) => {
  return (
    <div>
      {hasBadge && (
        <Typography className={styles.badge} variant={"h4"}>
          {badgeText}
        </Typography>
      )}

      <Typography className={styles.title} variant={"h1"}>
        {productName}
      </Typography>

      {!!description && (
        <Typography className={styles.description} variant={"body1"}>
          {description}
        </Typography>
      )}
    </div>
  );
};
